import { useMemo } from 'react';

import { useAuth } from '../context/AuthProvider';
import { UserRole } from '../types/users';
import {
    checkUserRole,
    isUserAdmin,
    normalizeAuthRole,
} from '../utility/userRoles';

export function useUser() {
    const { authUser, role: authRole } = useAuth();

    return useMemo(
        () => ({
            isStoreManager: checkUserRole(authUser, [UserRole.STORE_MANAGER]),
            isDivisionManager: checkUserRole(authUser, [
                UserRole.DIVISIONAL_MANAGER,
            ]),
            isOpsExecutive: checkUserRole(authUser, [UserRole.OPS_EXECUTIVE]),
            isProcurementManager: checkUserRole(authUser, [
                UserRole.PROCUREMENT_MANAGER,
            ]),
            isBusinessExecutive: checkUserRole(authUser, [
                UserRole.BUSINESS_LEADER,
                UserRole.DATA_STRATEGIST,
                UserRole.PROCUREMENT_MANAGER,
            ]),
            isAdmin: isUserAdmin(authUser),
            isSuperAdmin:
                authRole === 'superadmin' ||
                normalizeAuthRole(authUser?.userRole?.role) === 'superadmin' ||
                checkUserRole(authUser, [UserRole.SUPER_ADMIN]),
        }),
        [authUser, authRole],
    );
}
